// ~/plugins/check-version.client.js
export default () => {
  const currentVersion = '<%= require("../package.json").version %>';
  const storedVersion = localStorage.getItem('appVersion');
  const reloadFlag = 'hasReloadedForVersionMismatch';

  // Version mismatch handling
  if (storedVersion && storedVersion !== currentVersion && !sessionStorage.getItem(reloadFlag)) {
    console.warn(`[App] Version mismatch: ${storedVersion} → ${currentVersion}. Reloading...`);
    localStorage.setItem('appVersion', currentVersion);
    sessionStorage.setItem(reloadFlag, 'true'); // prevent reload loop
    window.location.reload(true);
    return;
  }

  localStorage.setItem('appVersion', currentVersion);
  sessionStorage.removeItem(reloadFlag); // reset for future versions

  // Handle missing chunk errors (dynamic import failures)
  window.addEventListener('error', (e) => {
    if (e.message && e.message.includes('Loading chunk')) {
      console.warn('[App] Missing chunk error. Reloading...');
      window.location.reload(true);
    }
  });

  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason && e.reason.message && e.reason.message.includes('Loading chunk')) {
      console.warn('[App] Unhandled missing chunk. Reloading...');
      window.location.reload(true);
    }
  });
};
